const getAllProperties = (obj) => {
  const allProps = [];
  let curr = obj;

  do {
    const props = Object.getOwnPropertyNames(curr);
    props.forEach(function(prop) {
      if (allProps.indexOf(prop) === -1) allProps.push(prop);
    });
  } while ((curr = Object.getPrototypeOf(curr)));

  return allProps;
};

const getCircularReplacer = () => {
  const seen = new WeakSet();
  return (key, value) => {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  };
};

window.addEventListener("click", (e) => {
  if (!navigator.sendBeacon) return;

  const url = "/b";

  const { testid, ...rest } = Object.assign({}, e.target.dataset);

  if (!testid) {
    return;
  }

  const data = {
    referrer: window.location.href,
    id: testid,
    href: e.target.getAttribute("href"),
    data: rest,
  };

  navigator.sendBeacon(url, JSON.stringify(data, getCircularReplacer()));
});
